import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EditEmployeeComponent } from './edit-employee.component';

const routes: Routes = [{ path: ':id', component: EditEmployeeComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditEmployeeRoutingModule {}
